module.exports = __webpack_public_path__ + "img/ajout_donnees_enfant.2f8bddb6.png";